import React from 'react';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { faqData } from '../../data/mock';

const FAQSection = () => {
  return (
    <section id="faq" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-200 rounded-full mb-6">
            <HelpCircle className="w-4 h-4 text-slate-600" />
            <span className="text-slate-700 text-sm font-semibold">Tire suas dúvidas</span>
          </div>
          
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Perguntas Frequentes
          </h2>
          
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Respostas diretas e transparentes sobre nossos serviços e atuação.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqData.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white border border-slate-200 rounded-2xl px-6 data-[state=open]:shadow-lg data-[state=open]:shadow-slate-100 transition-all duration-300"
            >
              <AccordionTrigger className="text-left py-6 text-lg font-semibold text-slate-800 hover:text-emerald-600 hover:no-underline [&[data-state=open]]:text-emerald-600">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-slate-600 leading-relaxed text-base">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional CTA */}
        <div className="mt-12 text-center">
          <p className="text-slate-600 mb-4">Ainda tem dúvidas?</p>
          <a
            href="#diagnostico"
            className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-semibold transition-colors duration-200"
          >
            <span>Entre em contato com nossa equipe</span>
            <span className="text-xl">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
